import { useContext } from 'react';
import { PusherContext } from '../../providers/PusherProvider';

export default function usePusher() {
  return useContext(PusherContext);
}
